// Module
var code = "<script>let $ctrl</script> <div class=\"grid-stack-item-content\"> <div class=\"grid-stack-item-content-inner\"> <molecule-panel-faq faq-article-id-list=\"$ctrl.faqArticleIdList\"></molecule-panel-faq> </div> </div> ";
// Exports
module.exports = code;